module.exports = __webpack_public_path__ + "fonts/iconfont.4df5ec2a.ttf";